module.exports = __webpack_public_path__ + "media/static/flags/fr-70c6574c830f2c4aae682a3b800d9a99.svg";